import { Swiper, Navigation, Mousewheel, Pagination, Scrollbar, Autoplay, EffectFade, FreeMode, Lazy, Thumbs, Controller} from 'swiper';
Swiper.use([Navigation, Mousewheel, Pagination, Scrollbar, Autoplay, EffectFade, FreeMode, Lazy, Thumbs, Controller]);


var swiperComponents = {
    init: function () {
        const cardSliderSwiper = new Swiper('.js-card-slider', {
            slidesPerView: 3,
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                830: {
                    slidesPerView: 2
                },
                1255: {
                    slidesPerView: 3
                },
                1670: {
                    slidesPerView: 4
                },
                2100: {
                    slidesPerView: 5
                }
            }
        });

        const cardSliderLoopSwiper = new Swiper('.js-card-slider-loop', {
            freemode: true,
            loop: true,
            allowSlidePrev: false,
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    loopedSlides: 3  // This ensures that there are no blank spaces between slides, when slides are shifting. 1 extra for each side
                },
                830: {
                    slidesPerView: 2,
                    loopedSlides: 4
                },
                1255: {
                    slidesPerView: 3,
                    loopedSlides: 5
                },
                1670: {
                    slidesPerView: 4,
                    loopedSlides: 6
                },
                2100: {
                    slidesPerView: 5,
                    loopedSlides: 7
                }
            },
            on: {
                loopFix: function (swiper) { // This to prevent showing of previous slide if resizing screen before sliding
                    swiper.allowSlidePrev = true;
                    swiper.navigation.prevEl.classList.remove("swiper-button-disabled", "swiper-button-lock");
                    swiper.$el[0].classList.add("active");
                }
            }
            // ,
            // onAny(eventName, ...args) {
            //     console.log("Eventname = ", eventName);
            //     console.log("Args = ", args);
            // }
        });

        // Gallery swipers
        var swipers = document.querySelectorAll('.js-gallery-swiper');
        if (swipers && swipers.length > 0) {
            swipers.forEach((swiperElement) => {

                // If thumn sliders are present, we activate with thumbs
                var thumb = swiperElement.parentElement.querySelector('.js-gallery-swiper-thumbs');
                if (thumb) {

                    // Initialize the thumbnails Swiper
                    const thumbsSwiper = new Swiper(thumb, {
                        loop: false,
                        spaceBetween: 10,
                        freeMode: false,
                        watchSlidesProgress: true,
                        slideToClickedSlide: true,
                        breakpoints: {
                            0: {
                                slidesPerView: 4
                            },
                            768: {
                                slidesPerView: 6
                            }
                        }
                    });

                    const gallerySwiper = new Swiper(swiperElement, {
                        slidesPerView: "auto",
                        pagination: {
                            el: ".swiper-pagination",
                            type: "fraction",
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        thumbs:{
                            swiper: thumbsSwiper
                        }
                    });
                } else {
                    const gallerySwiper = new Swiper(swiperElement, {
                        slidesPerView: "auto",
                        pagination: {
                            el: ".swiper-pagination",
                            type: "fraction",
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }
                    });
                }
            });
        }

        const weatherSwiper = new Swiper(".js-weather-swiper", {
            slidesPerView: "auto",
            direction: "horizontal",
            freeMode: true,
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: false
            },
            mousewheel: true
        });

        const buttonSwiper = new Swiper(".js-button-slider", {
            slidesPerView: "auto",
            freeMode: true,
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // Pretty hacky way to prevent pressing buttons when sliding
            on: {
                touchMove: function (swiper) {
                    let swiperButtons = swiper.wrapperEl.querySelectorAll("button");
                    swiperButtons.forEach(el => el.classList.add("pe-none"));
                },
                touchEnd: function (swiper) {
                    let swiperButtons = swiper.wrapperEl.querySelectorAll("button");
                    swiperButtons.forEach(el => el.classList.remove("pe-none"));
                },
                click: function(swiper, event) {
                    swiper.slideTo(swiper.clickedIndex);
                }
            }
        });

        const formSwiper = new Swiper(".js-form-swiper", {
            slidesPerView: "3",
            pagination: {
                el: ".swiper-pagination",
                type: "progressbar",
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1
                },
                690: {
                    slidesPerView: 2
                },
                1200: {
                    slidesPerView: 3
                },
                1720: {
                    slidesPerView: 4
                }
            }
        });

        const heroSwiper = new Swiper(".js-hero-swiper", {
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 4000
            },
            hashNavigation: {
                watchState: true,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            }
        });

        

    }
}

export default swiperComponents;